export default __webpack_public_path__ + "static/media/hm-pt-img.5e5e6d85.webp";